import React, { useEffect, useState } from "react";
import {
    Button,
    Container,
    Form,
    Spinner,
    Image,
} from "react-bootstrap";
import { decodeJwt } from "jose";
import LoginModal from "../LoginModal";
import { useHistory } from "react-router-dom";
import { isValidPassword } from "../../util/validity-helpers";
import PasswordControl from "../PasswordControl";
import { TriyoForm } from "../TriyoForm";
import TickedCircleGreen from "../../assets/icons/Checkbox-Circular-Ticked-14px-Green-60.svg";
import { getTokenFromHashbang, removeHashbangFromUrl } from "../../redux/auth/auth-utils";

import "./SetNewPassword.scss";
import { setNewPassword } from "../../services/api/auth";
import { errorNotification, successNotification } from "../../redux/notifications";
import { useDispatch } from "react-redux";

const SetNewPassword = () => {

    const history = useHistory();
    const dispatch = useDispatch();

    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("abc@triyo.com")
    const [password, setPassword] = useState("");
    const [confPassword, setConfPassword] = useState("");
    const [token, setToken] = useState("");
    const [passwordChanged, setPasswordChanged] = useState();

    const onSubmit = async () => {
        setLoading(true);
        setValidated(true);

        if (isValidPassword(password) && password === confPassword) {
            try {
                const result = await setNewPassword(password, token);
                if (result.status === 200) {
                    setPasswordChanged(true);
                    dispatch(successNotification({
                        header: "Password reset success",
                        message: "Your password was reset successfully."
                    }));
                }
                else {
                    throw new Error("Password reset Request didn't work!");
                }
            } catch {
                dispatch(errorNotification({
                    header: "Password reset failure",
                    message: "There was an error, please try again later."
                }));
            }

        }
        setLoading(false);
    }

    const backToLogin = () => {
        history.push("/login");
    }

    useEffect(() => {
        const tokenFromHashbang = getTokenFromHashbang();
        if (tokenFromHashbang) {
            removeHashbangFromUrl();
            const decode = decodeJwt(tokenFromHashbang);
            const expiry = new Date(decode.expiry);
            if (new Date() > new Date(expiry)) {
                dispatch(errorNotification({
                    header: "Link Expired",
                    message: "Please start with a new reset-link",
                }));
                history.push("/forgot-password");
            }
            setEmail(decode.email);
            setToken(tokenFromHashbang);
        }
        else {
            dispatch(errorNotification({
                header: "Invalid Link",
                message: "Please login to start using TRIYO",
            }));
            history.push("/");
        }
    }, [])

    return (
        <LoginModal>
            {!passwordChanged ?
                <Container className="set-new-password-form">
                    <h2>Set a new password</h2>
                    <TriyoForm>
                        <Form noValidate validated={validated} autoComplete="off">
                            <Form.Group>
                                <Form.Label className="email-label">Email address</Form.Label>
                                <Form.Control
                                    className="email-input input"
                                    type="text"
                                    value={email}
                                    disabled={true}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Set your new password</Form.Label>
                                <PasswordControl
                                    className="password-input input"
                                    onChange={setPassword}
                                    value={password}
                                    isInvalid={validated && !isValidPassword(password)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Confirm your new password</Form.Label>
                                <PasswordControl
                                    className="password-input input"
                                    onChange={setConfPassword}
                                    errorMessage="Passwords must match"
                                    value={confPassword}
                                    isInvalid={validated && (password !== confPassword)}
                                />
                            </Form.Group>
                            <Button className="next-button" onClick={onSubmit} disabled={loading}>
                                {loading && <Spinner className="nextButtonSpinner" as="span" animation="border" size="sm" role="status" />}
                                Continue
                            </Button>
                        </Form>
                    </TriyoForm>
                </Container>
                :
                <Container className="set-new-password-form">
                    <Image className="ticked-circle-green" src={TickedCircleGreen} />
                    <h3>
                        A password has been set for your account.
                    </h3>
                    <Button className="next-button" onClick={backToLogin} disabled={loading}>
                        Back to Login
                    </Button>
                </Container>
            }
        </LoginModal>
    );
}

export default SetNewPassword;